// Modules
export const SET_MODULE_OPTIONS = 'SET_MODULE_OPTIONS'
export const CREATE_MODULE = 'CREATE_MODULE'
export const UPDATE_MODULE = 'UPDATE_MODULE'
export const SET_OPERATIONS_DATA = 'SET_OPERATIONS_DATA'
export const SET_FORM_DATA = 'SET_FORM_DATA'
export const SET_MODULE_LIST_DATA = 'SET_MODULE_LIST_DATA'

// Settings
export const SET_ROLE_GROUP_LIST = 'SET_ROLE_GROUP_LIST'
export const SET_ROLE_GROUP_LIST_WITH_CHILDS = 'SET_ROLE_GROUP_LIST_WITH_CHILDS'
export const SET_MODULE_LIST_DATA_WITH_CHILDS = 'SET_MODULE_LIST_DATA_WITH_CHILDS'
export const SET_ROLES_LIST = 'SET_ROLES_LIST'
export const SET_STAFF_LIST_DATA = 'SET_STAFF_LIST_DATA'
export const SET_USER_COUNTRY_LOCATIONS_DATA = 'SET_USER_COUNTRY_LOCATIONS_DATA'
export const UNSET_USER_COUNTRY_LOCATIONS_DATA = 'UNSET_USER_COUNTRY_LOCATIONS_DATA'
export const SET_STATE_LIST_DATA = 'SET_STATE_LIST_DATA'
export const SET_CITY_LIST_DATA = 'SET_CITY_LIST_DATA'
export const SET_STOCK_LOCATION_LIST_DATA = 'SET_STOCK_LOCATION_LIST_DATA'
export const SET_ZONE_LIST_DATA = 'SET_ZONE_LIST_DATA'
export const SET_TAX_LIST_DATA = 'SET_TAX_LIST_DATA'
export const SET_DELIVERY_CHARGE_LIST_DATA = 'SET_DELIVERY_CHARGE_LIST_DATA'
export const SET_REPORT_CONFIGS_LIST_DATA = 'SET_REPORT_CONFIGS_LIST_DATA'
export const SET_MEMBERSHIP_ROLE_LIST_DATA = 'SET_MEMBERSHIP_ROLE_LIST_DATA'
export const SET_SETTINGS_ENROLLMENT_TYPE = 'SET_SETTINGS_ENROLLMENT_TYPE'
export const MEMBERSHIP_ROLE_LIST_ROLE_ROW_UPDATE = 'MEMBERSHIP_ROLE_LIST_ROLE_ROW_UPDATE'
export const SET_SETTINGS_CONFIG = 'SET_SETTINGS_CONFIG'
export const SET_ROLE_GROUP_DATA = 'SET_ROLE_GROUP_DATA'
export const SET_DEPARTMENT_LIST_DATA = 'SET_DEPARTMENT_LIST_DATA'
export const SET_DEPARTMENT_OPTIONS = 'SET_DEPARTMENT_OPTIONS'
export const SET_LOCATIONS_OPTIONS = 'SET_LOCATIONS_OPTIONS'
export const SET_CURRENCIES_LIST_DATA = 'SET_CURRENCIES_LIST_DATA'
export const SET_CURRENCIES_CONVERSIONS_LIST_DATA = 'SET_CURRENCIES_CONVERSIONS_LIST_DATA'

// Reports
export const SET_REPORT_LIST_DATA = 'SET_REPORT_LIST_DATA'
export const SET_EWALLET_REPORT_DATA = 'SET_EWALLET_REPORT_DATA'
export const SET_EWALLET_POPUP_REPORT_DATA = 'SET_EWALLET_POPUP_REPORT_DATA'
export const SET_EWALLET_INDIVIDUAL_REPORT_DATA = 'SET_EWALLET_INDIVIDUAL_REPORT_DATA'
export const SET_VISITOR_HISTORY_LIST_DATA = 'SET_VISITOR_HISTORY_LIST_DATA'

// Login
export const LOGIN = 'LOGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const SET_TOKEN = 'SET_TOKEN'
export const UNSET_TOKEN = 'UNSET_TOKEN'
export const SET_LOGIN_INFO = 'SET_LOGIN_INFO'

// Master
export const SET_MASTER_OPTIONS = 'SET_MASTER_OPTIONS'
export const SET_MASTER_FORM_DATA = 'SET_MASTER_FORM_DATA'
export const SET_MASTER_LIST_DATA = 'SET_MASTER_LIST_DATA'
// Master Data
export const SET_MASTER_DATA_OPTIONS = 'SET_MASTER_DATA_OPTIONS'
export const SET_MASTER_DATA_FORM_DATA = 'SET_MASTER_DATA_FORM_DATA'
export const SET_MASTER_DATA_LIST_DATA = 'SET_MASTER_DATA_LIST_DATA'

// Errors
export const CLEAR_VALIDATION = 'CLEAR_VALIDATION'
export const VALIDATION_FAILED = 'VALIDATION_FAILED'

// Global
export const IS_PROCESSING = 'IS_PROCESSING'
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'
export const RESET_ERRORS = 'RESET_ERRORS'
export const OPEN_CLOSE_MODAL_FORM = 'OPEN_CLOSE_MODAL_FORM'
export const CURRENT_UPDATE_ID = 'CURRENT_UPDATE_ID'
export const CLEAR_UPDATE_ID = 'CLEAR_UPDATE_ID'
export const IS_PROCESSING_FORM = 'IS_PROCESSING_FORM'
export const IS_PROCESSING_TABLE = 'IS_PROCESSING_TABLE'
export const IS_PROCESSING_LIST = 'IS_PROCESSING_LIST'
export const IS_PROCESSING_SECTION = 'IS_PROCESSING_SECTION'
export const IS_PROCESSING_VALIDATION = 'IS_PROCESSING_VALIDATION'
export const IS_PROCESSING_CROSS_VALIDATION = 'IS_PROCESSING_CROSS_VALIDATION'
export const IS_PROCESSING_REDIRECT = 'IS_PROCESSING_REDIRECT'
export const SET_USER_TYPES = 'SET_USER_TYPES'
export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS'
export const SET_SIMPLE_PAGINATION_DATA = 'SET_SIMPLE_PAGINATION_DATA'
export const SET_COUNTRIES = 'SET_COUNTRIES'
export const SET_COUNTRIES_CALL_CODE = 'SET_COUNTRIES_CALL_CODE'
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_MASTER_DATA = 'SET_MASTER_DATA'
export const SET_LANGUAGES = 'SET_LANGUAGES'
export const SET_DYNAMIC_CONTENT_DATA = 'SET_DYNAMIC_CONTENT_DATA'
export const SET_COUNTRIES_STATE_CITIES = 'SET_COUNTRIES_STATE_CITIES'
export const SET_COUNTRIES_STATES = 'SET_COUNTRIES_STATES'
export const SET_TRASH_DATA = 'SET_TRASH_DATA'
export const SET_COUNTRIES_BANKS = 'SET_COUNTRIES_BANKS'
export const SET_DONE = 'SET_DONE'
export const SET_MEMBER_SEARCH_DATA = 'SET_MEMBER_SEARCH_DATA'
export const SET_COUNTRY_RELATION_DATA = 'SET_COUNTRY_RELATION_DATA'
export const SET_HEADER_SEARCH_BAR_FIELD = 'SET_HEADER_SEARCH_BAR_FIELD'
export const SET_COMMISSION_WEEK_SEARCH_DATA = 'SET_COMMISSION_WEEK_SEARCH_DATA'
export const SET_USER_INFO = 'SET_USER_INFO'
export const UNSET_SIMPLE_PAGINATION_DATA = 'UNSET_SIMPLE_PAGINATION_DATA'
export const SET_WEBSOCKET_STATUS = 'SET_WEBSOCKET_STATUS'
export const WRITE_CHANNEL_DATA = 'WRITE_CHANNEL_DATA'
export const UNSET_CHANNEL_DATA = 'UNSET_CHANNEL_DATA'
export const IS_PROCESSING_REFRESH_TOKEN = 'IS_PROCESSING_REFRESH_TOKEN'
export const SET_FILTER_DATA = 'SET_FILTER_DATA'
export const UNSET_FILTER_DATA = 'UNSET_FILTER_DATA'
export const SET_GIRO_TYPE = 'SET_GIRO_TYPE'
export const SET_STOCK_LOCATIONS = 'SET_STOCK_LOCATIONS'
export const SET_LOCATION_TYPES = 'SET_LOCATION_TYPES'
export const SET_CANCEL_TOKEN = 'SET_CANCEL_TOKEN'
export const SET_MASTER_DATA_BY_KEY = 'SET_MASTER_DATA_BY_KEY'
export const SET_ALL_COUNTRIES = 'SET_ALL_COUNTRIES'
export const SET_ADDITIONAL_REQUIREMENTS_QUANTITY = 'SET_ADDITIONAL_REQUIREMENTS_QUANTITY'
export const SET_IS_UPDATE_AVAILABLE = 'SET_IS_UPDATE_AVAILABLE'
export const UNSET_ADDITIONAL_REQUIREMENTS_QUANTITY = 'UNSET_ADDITIONAL_REQUIREMENTS_QUANTITY'
export const SOCKET_CONNECT = 'SOCKET_CONNECT'
export const SOCKET_DISCONNECT = 'SOCKET_DISCONNECT'
export const SET_QUEUE_REQUEST_RESPONSE = 'SET_QUEUE_REQUEST_RESPONSE'
export const SET_USER_FIELD_VALIDATION = 'SET_USER_FIELD_VALIDATION'
export const SET_AREA = 'SET_AREA'
export const SET_CLASSIC_CROSS_SPONSORING_CHECK = 'SET_CLASSIC_CROSS_SPONSORING_CHECK'
export const RESET_USER_FIELD_VALIDATIONS = 'RESET_USER_FIELD_VALIDATIONS'
export const SET_USER_AUTHORIZED_REPORTS = 'SET_USER_AUTHORIZED_REPORTS'
export const SET_BUILDER_ROLE_PERMISSIONS = 'SET_BUILDER_ROLE_PERMISSIONS'
export const SET_STANDARD_MENU = 'SET_STANDARD_MENU'
export const SET_ERROR_OCCURRED = 'SET_ERROR_OCCURRED'
export const SET_ROUTES = 'SET_ROUTES'
export const SET_COUNTRIES_CALL_CODE_BY_COUNTRY_NAME = 'SET_COUNTRIES_CALL_CODE_BY_COUNTRY_NAME'
export const SET_STOCKIST_STATE_AND_CITIES = 'SET_STOCKIST_STATE_AND_CITIES'
export const SET_LIST_ITEMS_DATA = 'SET_LIST_ITEMS_DATA'
export const SET_LOADING = 'SET_LOADING'
export const SET_ROUNDING_CALCULATION = 'SET_ROUNDING_CALCULATION'

// Products
export const SET_PRODUCT_PAGE_DATA = 'SET_PRODUCT_PAGE_DATA'
export const SET_PRODUCT_LIST_DATA = 'SET_PRODUCT_LIST_DATA'
export const SET_PRODUCT_SEARCH_DATA = 'SET_PRODUCT_SEARCH_DATA'
export const SET_PRODUCT_DATA = 'SET_PRODUCT_DATA'
export const UPLOAD_IMAGES = 'UPLOAD_IMAGES'
export const SET_PRODUCT_IMAGES = 'SET_PRODUCT_IMAGES'
export const REMOVE_UPLOAD_IMAGE = 'REMOVE_UPLOAD_IMAGE'
export const SET_PRODUCT_IMAGE_DEFAULT = 'SET_PRODUCT_IMAGE_DEFAULT'
export const REMOVE_DEFAULT_IMAGE = 'REMOVE_DEFAULT_IMAGE'
export const UNSET_PRODUCT_DATA = 'UNSET_PRODUCT_DATA'
export const SET_PRODUCT_LESS_DATA = 'SET_PRODUCT_LESS_DATA'
export const SET_KITTING_LIST_DATA = 'SET_KITTING_LIST_DATA'
export const SET_PRODUCT_KITTING_DATA = 'SET_PRODUCT_KITTING_DATA'
export const SET_PRODUCT_GROUPING_LIST_DATA = 'SET_PRODUCT_GROUPING_LIST_DATA'
export const SET_PRODUCT_GROUPING_DATA = 'SET_PRODUCT_GROUPING_DATA'
export const SET_PRODUCT_CATEGORIES_LIST_DATA = 'SET_PRODUCT_CATEGORIES_LIST_DATA'
export const SET_PWP_FOC_LIST_DATA = 'SET_PWP_FOC_LIST_DATA'
export const SET_PWP_FOC_DATA = 'SET_PWP_FOC_DATA'
export const SET_KITTING_QUALIFIED_BASE_CVS = 'SET_KITTING_QUALIFIED_BASE_CVS'
export const SET_KITTING_STATS_DATA = 'SET_KITTING_STATS_DATA'

// members
export const SET_MEMBER_TREE = 'SET_MEMBER_TREE'
export const SET_MEMBER_TABS_DATA = 'SET_MEMBER_TABS_DATA'
export const SET_MEMBER_LIST_DATA = 'SET_MEMBER_LIST_DATA'
export const SET_MEMBERS_TREE = 'SET_MEMBERS_TREE'
export const SET_MEMBER_DATA = 'SET_MEMBER_DATA'
export const SET_MEMBERS_MULTI_FUNCTIONAL_TREE = 'SET_MEMBERS_MULTI_FUNCTIONAL_TREE'
export const SET_MEMBER_RANK_LIST_DATA = 'SET_MEMBER_RANK_LIST_DATA'
export const SET_MEMBER_HIGHEST_RANK_LIST = 'SET_MEMBER_HIGHEST_RANK_LIST'
export const SET_MEMBER_ENROLLMENT_RANK_LIST = 'SET_MEMBER_ENROLLMENT_RANK_LIST'
export const SET_MEMBER_MIGRATION_LIST_DATA = 'SET_MEMBER_MIGRATION_LIST_DATA'
export const SET_MEMBERS_STATUS_LIST = 'SET_MEMBERS_STATUS_LIST'
export const UNSET_MEMBER_DATA = 'UNSET_MEMBER_DATA'
export const SET_MEMBER_TRANSACTION_LIST_DATA = 'SET_MEMBER_TRANSACTION_LIST_DATA'
export const SET_MEMBER_SALES_HISTORY_LIST_DATA = 'SET_MEMBER_SALES_HISTORY_LIST_DATA'
export const SET_MEMBERS_ON_BEHALF_TOKEN = 'SET_MEMBERS_ON_BEHALF_TOKEN'
export const SET_MEMBER_NEXT_PLACEMENT_POSITION = 'SET_MEMBER_NEXT_PLACEMENT_POSITION'
export const SET_MEMBER_COUNCIL_RANK_LIST = 'SET_MEMBER_COUNCIL_RANK_LIST'
export const SET_MEMBER_PERFORMANCE_DATA = 'SET_MEMBER_PERFORMANCE_DATA'
export const SET_MEMBER_SPONSOR_LISTING_DATA = 'SET_MEMBER_SPONSOR_LISTING_DATA'
export const UNSET_MEMBER_SPONSOR_LISTING_DATA = 'UNSET_MEMBER_SPONSOR_LISTING_DATA'
export const SET_MEMBER_SPONSOR_LISTING_FILTERS_DATA = 'SET_MEMBER_SPONSOR_LISTING_FILTERS_DATA'

// sales
export const SET_SALES_LIST_DATA = 'SET_SALES_LIST_DATA'
export const SET_ORDER_DATA = 'SET_ORDER_DATA'
export const UNSET_ORDER_DATA = 'UNSET_ORDER_DATA'
export const SET_SALES_PRODUCTS_LIST_DATA = 'SET_SALES_PRODUCTS_LIST_DATA'
export const SET_SALES_INVOICE_LIST_DATA = 'SET_SALES_INVOICE_LIST_DATA'
export const UNSET_ORDER_CANCELLATION_DATA = 'UNSET_ORDER_CANCELLATION_DATA'
export const SET_ORDER_CANCELLATION_DATA = 'SET_ORDER_CANCELLATION_DATA'
export const SET_ORDER_CANCELLATION_SEARCH_LIST = 'SET_ORDER_CANCELLATION_SEARCH_LIST'
export const SET_CART_PWP_VALIDATION_IDS = 'SET_CART_PWP_VALIDATION_IDS'
export const UNSET_CART_PWP_VALIDATION_IDS = 'UNSET_CART_PWP_VALIDATION_IDS'
export const SET_CART_PWP_ITEM_TEMP_LIST = 'SET_CART_PWP_ITEM_TEMP_LIST'
export const UNSET_CART_PWP_ITEM_TEMP_LIST = 'UNSET_CART_PWP_ITEM_TEMP_LIST'
export const SET_PAYMENT_OPTIONS = 'SET_PAYMENT_OPTIONS'
export const SET_SALES_DATA = 'SET_SALES_DATA'
export const SET_SALES_ADDRESSES_DATA = 'SET_SALES_ADDRESSES_DATA'
export const IS_PROCESSING_CART = 'IS_PROCESSING_CART'
export const UNSET_SALES_ADDRESSES_DATA = 'UNSET_SALES_ADDRESSES_DATA'
export const SET_PRODUCT_EXCHANGE_DATA = 'SET_PRODUCT_EXCHANGE_DATA'
export const UNSET_PRODUCT_EXCHANGE_DATA = 'UNSET_PRODUCT_EXCHANGE_DATA'
export const ADD_UPDATE_PROMOTIONAL_ROW_CURRENT_STATUS = 'ADD_UPDATE_PROMOTIONAL_ROW_CURRENT_STATUS'
export const UNSET_PROMOTIONAL_ROW_CURRENT_STATUS = 'UNSET_PROMOTIONAL_ROW_CURRENT_STATUS'
export const SET_PRODUCT_EXCHANGE_SEARCH_LIST = 'SET_PRODUCT_EXCHANGE_SEARCH_LIST'
export const SET_AEON_SEARCH_LIST = 'SET_AEON_SEARCH_LIST'
export const SET_EPP_SEARCH_LIST = 'SET_EPP_SEARCH_LIST'
export const SET_SALES_EXCHANGE_DATA = 'SET_SALES_EXCHANGE_DATA'
export const SET_TAX_INVOICE_LISTING = 'SET_TAX_INVOICE_LISTING'
export const SET_EPP_MOTO_APPROVAL_RESPONSE_DATA = 'SET_EPP_MOTO_APPROVAL_RESPONSE_DATA'
export const SET_EPP_MOTO_REJECTION_RESPONSE_DATA = 'SET_EPP_MOTO_REJECTION_RESPONSE_DATA'
export const SET_BACK_OFFICE_ENROLLMENT_TYPE = 'SET_BACK_OFFICE_ENROLLMENT_TYPE'
export const SET_CART_ADDITIONAL_ATTRIBUTES_INCOMPLETE_IDS = 'SET_CART_ADDITIONAL_ATTRIBUTES_INCOMPLETE_IDS'
export const UNSET_CART_ADDITIONAL_ATTRIBUTES_INCOMPLETE_IDS = 'UNSET_CART_ADDITIONAL_ATTRIBUTES_INCOMPLETE_IDS'
export const SET_BACK_OFFICE_ENROLLMENT_RANK = 'SET_BACK_OFFICE_ENROLLMENT_RANK'
export const UNSET_SALES_PRODUCTS_LIST_DATA = 'UNSET_SALES_PRODUCTS_LIST_DATA'
export const SET_SALE_ELIGIBLE_ERROR = 'SET_SALE_ELIGIBLE_ERROR'
export const SET_SALE_ELIGIBLE_TRANSFER_SEARCH = 'SET_SALE_ELIGIBLE_TRANSFER_SEARCH'
export const SET_SALE_TRANSFER_DATA = 'SET_SALE_TRANSFER_DATA'
export const UNSET_SALE_TRANSFER_DATA = 'UNSET_SALE_TRANSFER_DATA'
export const SET_SALE_SV_TRANSFER_BY_PRODUCT_ITEMS = 'SET_SALE_SV_TRANSFER_BY_PRODUCT_ITEMS'
export const SET_SV_TRANSFER_BY_PRODUCT_FORM_DATA = 'SET_SV_TRANSFER_BY_PRODUCT_FORM_DATA'
export const UNSET_SV_TRANSFER_BY_PRODUCT_DATA = 'UNSET_SV_TRANSFER_BY_PRODUCT_DATA'
export const SET_SALES_RECORD_SEARCH_LIST = 'SET_SALES_RECORD_SEARCH_LIST'

// smart library
export const SET_SMART_LIBRARY_LIST_DATA = 'SET_SMART_LIBRARY_LIST_DATA'
export const SET_SMART_LIBRARY_DATA = 'SET_SMART_LIBRARY_DATA'
export const SET_SMART_LIBRARY_OPTIONS = 'SET_SMART_LIBRARY_OPTIONS'
export const SET_SMART_LIBRARY_FORM_DATA = 'SET_SMART_LIBRARY_FORM_DATA'
export const SET_SMART_LIBRARY_PRODUCT_DATA = 'SET_SMART_LIBRARY_PRODUCT_DATA'
export const SET_SMART_LIBRARY_FILE_TYPE_DATA = 'SET_SMART_LIBRARY_FILE_TYPE_DATA'
export const SET_SMART_LIBRARY_EFORM_LIST_DATA = 'SET_SMART_LIBRARY_EFORM_LIST_DATA'

// stockist
export const SET_STOCKIST_REGISTRATION_DATA = 'SET_STOCKIST_REGISTRATION_DATA'
export const UNSET_STOCKIST_REGISTRATION_DATA = 'UNSET_STOCKIST_REGISTRATION_DATA'
export const SET_STOCKIST_REGISTRATION_LIST = 'SET_STOCKIST_REGISTRATION_LIST'
export const UNSET_STOCKIST_REGISTRATION_LIST = 'UNSET_STOCKIST_REGISTRATION_LIST'
export const SET_STOCKIST_DATA = 'SET_STOCKIST_DATA'
export const SET_STOCKIST_ORDER_RETURN_LIST = 'SET_STOCKIST_ORDER_RETURN_LIST'
export const SET_STOCKIST_DEPOSIT_REFUND_LIST = 'SET_STOCKIST_DEPOSIT_REFUND_LIST'
export const SET_STOCKIST_LIST_SEARCH_DATA = 'SET_STOCKIST_LIST_SEARCH_DATA'
export const SET_STOCKIST_DAILY_TRANSACTION_LIST = 'SET_STOCKIST_DAILY_TRANSACTION_LIST'
export const SET_STOCKIST_DAILY_TRANSACTION_PAYMENTS = 'SET_STOCKIST_DAILY_TRANSACTION_PAYMENTS'
export const SET_STOCKIST_SEARCH_PRODUCT = 'SET_STOCKIST_SEARCH_PRODUCT'
export const SET_STOCKIST_AR_SUMMARY_LIST = 'SET_STOCKIST_AR_SUMMARY_LIST'
export const SET_STOCKIST_CONSIGNMENT_BALANCE_CALCULATION_STATUS = 'SET_STOCKIST_CONSIGNMENT_BALANCE_CALCULATION_STATUS'

// Uploader
export const SET_UPLOADER_FILE_UPLOAD_SETTING = 'SET_UPLOADER_FILE_UPLOAD_SETTING'
export const SET_UPLOADER_FILE_UPLOAD_PROCESS = 'SET_UPLOADER_FILE_UPLOAD_PROCESS'

// Campaign
export const SET_CAMPAIGN_LOCATION_LIST_DATA = 'SET_CAMPAIGN_LOCATION_LIST_DATA'
export const SET_TEAM_BONUS_RANK_LIST_DATA = 'SET_TEAM_BONUS_RANK_LIST_DATA'
export const SET_ENROLLMENT_RANK_LIST_DATA = 'SET_ENROLLMENT_RANK_LIST_DATA'
export const SET_CAMPAIGN_LIST_DATA = 'SET_CAMPAIGN_LIST_DATA'
export const SET_CAMPAIGN_FORM_DATA = 'SET_CAMPAIGN_FORM_DATA'
export const SET_ESAC_VOUCHER_TYPE_LIST_DATA = 'SET_ESAC_VOUCHER_TYPE_LIST_DATA'
export const SET_ESAC_VOUCHER_TYPE_FORM_DATA = 'SET_ESAC_VOUCHER_TYPE_FORM_DATA'
export const SET_ESAC_VOUCHER_SUB_TYPE_LIST_DATA = 'SET_ESAC_VOUCHER_SUB_TYPE_LIST_DATA'
export const SET_ESAC_VOUCHER_SUB_TYPE_FORM_DATA = 'SET_ESAC_VOUCHER_SUB_TYPE_FORM_DATA'
export const SET_ESAC_PROMOTION_LIST_DATA = 'SET_ESAC_PROMOTION_LIST_DATA'
export const SET_ESAC_PROMOTION_FORM_DATA = 'SET_ESAC_PROMOTION_FORM_DATA'
export const SET_ESAC_VOUCHER_LIST_DATA = 'SET_ESAC_VOUCHER_LIST_DATA'
export const SET_ESAC_VOUCHER_FORM_DATA = 'SET_ESAC_VOUCHER_FORM_DATA'
export const SET_ESAC_REDEMPTION_LIST_DATA = 'SET_ESAC_REDEMPTION_LIST_DATA'
export const SET_ESAC_REDEMPTION_FORM_DATA = 'SET_ESAC_REDEMPTION_FORM_DATA'
export const SET_ESAC_REDEMPTION_DATA = 'SET_ESAC_REDEMPTION_DATA'
export const UNSET_ESAC_REDEMPTION_DATA = 'UNSET_ESAC_REDEMPTION_DATA'
export const SET_BONUS_ADJUSTMENT_LIST_DATA = 'SET_BONUS_ADJUSTMENT_LIST_DATA'
export const SET_PAYMENT_WITH_MONETARY_VALUE_OPTIONS = 'SET_PAYMENT_WITH_MONETARY_VALUE_OPTIONS'

// wallet
export const SET_WALLET_DATA = 'SET_WALLET_DATA'
export const UNSET_WALLET_DATA = 'UNSET_WALLET_DATA'
export const SET_WALLET_ADJUSTMENT_LIST = 'SET_WALLET_ADJUSTMENT_LIST'
export const SET_WALLET_GIRO_PAYMENT_LIST = 'SET_WALLET_GIRO_PAYMENT_LIST'
export const SET_WALLET_GIRO_REJECTED_PAYMENT_LIST = 'SET_WALLET_GIRO_REJECTED_PAYMENT_LIST'
export const SET_WALLET_GIRO_REJECTED_PAYMENT_RESPONSE = 'SET_WALLET_GIRO_REJECTED_PAYMENT_RESPONSE'
export const SET_MEMBER_WALLET_DATA = 'SET_MEMBER_WALLET_DATA'

// eVoucher
export const SET_EVOUCHER_LIST_DATA = 'SET_EVOUCHER_LIST_DATA'
export const SET_EVOUCHER_DATA = 'SET_EVOUCHER_DATA'
export const SET_EVOUCHER_ACTIVATION_DATA = 'SET_EVOUCHER_ACTIVATION_DATA'
export const SET_EVOUCHER_ACTIVATION_CODE_DATA = 'SET_EVOUCHER_ACTIVATION_CODE_DATA'
export const UNSET_EVOUCHER_ACTIVATION_DATA = 'UNSET_EVOUCHER_ACTIVATION_DATA'

// AUTOSHIP ============================================================================================================
export const UPDATE_CARD_LIST = 'UPDATE_CLASS_LIST'
export const SET_SHIP_CYCLE = 'SET_SHIP_CYCLE'
export const SET_PAYMENT_INFO = 'SET_PAYMENT_INFO'
export const SET_SHIPPING_INFO = 'SET_SHIPPING_INFO'
export const SET_BILLING_INFO = 'SET_BILLING_INFO'
export const SET_AUTOSHIP_SUBSCRIPTION_LIST = 'SET_AUTOSHIP_SUBSCRIPTION_LIST'
export const SET_SUBSCRIPTION_LIST_PAGINATION_META = 'SET_SUBSCRIPTION_LIST_PAGINATION_META'
export const SET_AUTOSHIP_SUBSCRIPTION_DETAIL = 'SET_AUTOSHIP_SUBSCRIPTION_DETAIL'
export const CLEAR_AUTOSHIP_DATA = 'CLEAR_AUTOSHIP_DATA'
export const AUTOSHIP_DATA = 'AUTOSHIP_DATA'

// RECEIPT =============================================================================================================
export const SET_RECEIPT_UPLOAD_DATA = 'SET_RECEIPT_UPLOAD_DATA'
export const SET_GENERAL_RECEIPT_DATA = 'SET_GENERAL_RECEIPT_DATA'
export const SET_GENERAL_RECEIPT_LIST_DATA = 'SET_GENERAL_RECEIPT_LIST_DATA'
export const SET_RECEIPT_RECEIPT_CANCELLATION_DATA = 'SET_RECEIPT_RECEIPT_CANCELLATION_DATA'

// BONUS +============================================================================================================
export const SET_BONUS_DATA = 'SET_BONUS_DATA'
export const UNSET_BONUS_DATA = 'UNSET_BONUS_DATA'

// ITOKEN ==============================================================================================================
export const SET_ITOKEN_VOUCHER_DATA = 'SET_ITOKEN_VOUCHER_DATA'
export const SET_ITOKEN_VOUCHER_LIST = 'SET_ITOKEN_VOUCHER_LIST'
export const SET_ITOKEN_CAMPAIGN_LIST = 'SET_ITOKEN_CAMPAIGN_LIST'
export const SET_ITOKEN_CAMPAIGN_DATA = 'SET_ITOKEN_CAMPAIGN_DATA'
export const SET_ITOKEN_REDEMPTION_LIST = 'SET_ITOKEN_REDEMPTION_LIST'
export const SET_ITOKEN_REDEMPTION_DATA = 'SET_ITOKEN_REDEMPTION_DATA'
export const SET_ITOKEN_ACCUMULATE_CALCULATION_LIST = 'SET_ITOKEN_ACCUMULATE_CALCULATION_LIST'

//ESAC POINTS
export const SET_ESAC_POINTS_VOUCHER_DATA = 'SET_ESAC_POINTS_VOUCHER_DATA'
export const SET_ESAC_POINTS_VOUCHER_LIST = 'SET_ESAC_POINTS_VOUCHER_LIST'
export const SET_ESAC_POINTS_REDEMPTION_LIST = 'SET_ESAC_POINTS_REDEMPTION_LIST'
export const SET_ESAC_POINTS_REDEMPTION_DATA = 'SET_ESAC_POINTS_REDEMPTION_DATA'
export const SET_ESAC_POINTS_BALANCE = 'SET_ESAC_POINTS_BALANCE'
